import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/admin', label: 'Overview', icon: 'bi-grid-1x2-fill', end: true },
  { to: '/admin/stores', label: 'Stores', icon: 'bi-shop' },
  { to: '/admin/users', label: 'Users', icon: 'bi-people-fill' },
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const linkStyle = (isActive) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '0.7rem 1.25rem',
    borderRadius: 8,
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: isActive ? 600 : 400,
    color: isActive ? '#FF385C' : '#4b5563',
    background: isActive ? '#fff1f3' : 'transparent',
    transition: 'all 0.15s ease',
  });

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {/* Mobile hamburger */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        style={{
          position: 'fixed', top: 14, left: 14, zIndex: 1100,
          background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8,
          padding: '0.5rem 0.65rem', cursor: 'pointer', display: 'none',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        }}
        className="admin-hamburger"
      >
        <i className={`bi ${sidebarOpen ? 'bi-x-lg' : 'bi-list'}`} style={{ fontSize: '1.2rem' }} />
      </button>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1000 }}
          className="admin-overlay"
        />
      )}

      {/* Sidebar */}
      <aside
        className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}
        style={{
          width: 240,
          background: '#fff',
          borderRight: '1px solid #e5e7eb',
          display: 'flex',
          flexDirection: 'column',
          padding: '1.5rem 1rem',
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          zIndex: 1050,
          transition: 'transform 0.2s ease',
        }}
      >
        <div style={{ marginBottom: '2rem', padding: '0 0.5rem' }}>
          <div style={{ fontSize: '1.2rem', fontWeight: 700, color: '#FF385C' }}>StoreToyou</div>
          <div style={{ fontSize: '0.75rem', color: '#9ca3af', fontWeight: 500 }}>Admin Dashboard</div>
        </div>

        <nav style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setSidebarOpen(false)}
              style={({ isActive }) => linkStyle(isActive)}
            >
              <i className={`bi ${item.icon}`} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '1rem', display: 'flex', flexDirection: 'column', gap: 4 }}>
          <a href="/" style={linkStyle(false)}>
            <i className="bi bi-arrow-left" />
            Back to Site
          </a>
          <button onClick={handleLogout} style={{ ...linkStyle(false), border: 'none', background: 'none', cursor: 'pointer', width: '100%' }}>
            <i className="bi bi-box-arrow-right" />
            Logout
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{ flex: 1, marginLeft: 240, background: '#f3f4f6', minHeight: '100vh' }} className="admin-main">
        <div style={{ padding: '2rem', maxWidth: 1200, margin: '0 auto' }}>
          <Outlet />
        </div>
      </main>

      <style>{`
        @media (max-width: 768px) {
          .admin-hamburger { display: block !important; }
          .admin-sidebar { transform: translateX(-100%); }
          .admin-sidebar.open { transform: translateX(0); }
          .admin-main { margin-left: 0 !important; }
        }
      `}</style>
    </div>
  );
};

export default AdminLayout;
